import { createContext } from 'react'
import { SupportedLocale } from '../i18n'

export interface LanguageContextType {
  locale: SupportedLocale
  setLocale: (locale: SupportedLocale) => void
  isLoading: boolean
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined)